// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1582":"48a94b7fe5e149c0","3323":"3c0c4030482d8130","8957":"17c5970a05e88909"}[chunkId] + ".css";
};